<div  class="{{ gs.isVersion2 ? '' : 'form-input-select' }} {{config.class}}">
  <div class="default-sub-header text-label">{{config.label | translate}} @if (config.isMandatory) {
    <span class="mandatory-field">*</span>
  }</div>
  <div class="group-elements">
    <mat-form-field class="dropdown" [ngClass]="{'input-with-boundary':config.appearance}" appearance="outline">
      <mat-select (selectionChange)="selectedOption($event)" [(value)]="config.value" [disabled]="config.disableSelect">
        @for (option of config.options; track option) {
          <mat-option [value]="option.id">{{option.value}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field [formGroup]="group" class="text-field" [ngClass]="{'input-with-boundary':config.appearance}" appearance="outline">
      <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'" [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null"
        [maxlength]="this.dfs.requiredPhoneNumberLength$" [formControlName]="config.name" (keyup)="onKeyup($event)"   phoneNumber>

        @if (group.controls[FormControlName].hasError('required') && config.showErrorText) {
          <mat-error
            >
            {{config.errorMessage | translate}}
          </mat-error>
        }
        @if ((group.controls[FormControlName].hasError('minlength') || group.controls[FormControlName].hasError('maxlength')) && config.showErrorText) {
          <mat-error>
            {{'invalidPhone' | translate}}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>